import React from "react";
import "./style.css";
import { NavHashLink as Link } from "react-router-hash-link";
import styled, { keyframes } from "styled-components";
import { fadeIn } from "react-animations";

//Animations
const fadeInAnimation = keyframes`${fadeIn}`;
const FadeInDiv = styled.div`
  animation: 1.5s ${fadeInAnimation};
`;

class Sidedrawer extends React.Component {
  render() {
    let drawerClasses = "side-drawer";
    if (this.props.drawerState) {
      drawerClasses = "side-drawer open";
    }

    const toggle = () => {
      this.props.toggleDrawer();
    };
    return (
      <nav className={drawerClasses}>
        <div className="list-items">
          <Link
            smooth
            onClick={toggle}
            className="item-border"
            activeClassName="item-border active"
            // scroll={(el) => scrollWithOffset(el)}
            to="/#home"
          >
            <div className="item">
              {this.props.drawerState ? <FadeInDiv>HOME</FadeInDiv> : <>HOME</>}
            </div>
          </Link>

          <Link
            smooth
            onClick={toggle}
            className="item-border"
            activeClassName="item-border active"
            // scroll={(el) => scrollWithOffset(el)}
            to="/#about"
          >
            <div className="item">
              {this.props.drawerState ? (
                <FadeInDiv>ABOUT</FadeInDiv>
              ) : (
                <>ABOUT</>
              )}
            </div>
          </Link>

          <Link
            smooth
            onClick={toggle}
            className="item-border"
            activeClassName="item-border active"
            // scroll={(el) => scrollWithOffset(el)}
            to="/#projects"
          >
            <div className="item">
              {this.props.drawerState ? (
                <FadeInDiv>MY WORK</FadeInDiv>
              ) : (
                <>MY WORK</>
              )}
            </div>
          </Link>

          <Link
            smooth
            onClick={toggle}
            className="item-border"
            activeClassName="item-border active"
            // scroll={(el) => scrollWithOffset(el)}
            to="/#contact"
          >
            <div className="item">
              {this.props.drawerState ? (
                <FadeInDiv>CONTACT</FadeInDiv>
              ) : (
                <>CONTACT</>
              )}
            </div>
          </Link>
        </div>
      </nav>
    );
  }
}

export default Sidedrawer;
